var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApiService } from './api.service';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
var BountyService = /** @class */ (function () {
    function BountyService(apiService) {
        this.apiService = apiService;
    }
    BountyService.prototype.list = function (_a) {
        var _b = _a.page, page = _b === void 0 ? 1 : _b, filters = _a.filters, sort = _a.sort, tab = _a.tab, search = _a.search;
        return __awaiter(this, void 0, void 0, function () {
            var filtersString, sortString, tabString, searchString;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        filtersString = filters.length
                            ? "&filters=" + filters.join(',')
                            : '';
                        sortString = sort ? "&sort=" + sort : '';
                        tabString = tab ? "&tab=" + tab : '';
                        searchString = search ? "&search=" + search : '';
                        return [4 /*yield*/, this.apiService
                                .get("bounties?page=" + page + filtersString + sortString + tabString + searchString)
                                .toPromise()];
                    case 1: return [2 /*return*/, (_c.sent())];
                }
            });
        });
    };
    BountyService.prototype.getUserProfile = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.get("user/" + id).toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BountyService.prototype.get = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.get("bounties/" + id).toPromise()];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        });
    };
    BountyService.prototype.getClaim = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.get("claims/" + id).toPromise()];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        });
    };
    BountyService.prototype.create = function (bounty) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService
                            .post('bounties', bounty).toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BountyService.prototype.update = function (bounty, bountyId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService
                            .patch("bounties/" + bountyId, bounty).toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BountyService.prototype.deleteBounty = function (bountyId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.delete("bounties/" + bountyId, {}).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BountyService.prototype.submitClaim = function (bountyId, evidence) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService
                            .post("bounties/" + bountyId + "/submit-claim", { evidence: evidence })
                            .toPromise()];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        });
    };
    BountyService.prototype.setClaimWinner = function (claimId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService
                            .post("claims/" + claimId + "/accept-claim", {})
                            .toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BountyService.prototype.denyClaim = function (claimId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.post("claims/" + claimId + "/deny-claim", {}).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BountyService.prototype.markPaymentReceived = function (claimId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService
                            .post("claims/" + claimId + "/payment-received", {})
                            .toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BountyService.prototype.getBountyTitle = function (bounty) {
        switch (bounty.type) {
            case 'beatmap':
                return bounty.beatmap_name;
            case 'pp':
                if (bounty.pp_type === 'single') {
                    return "Single PP score bounty";
                }
                else {
                    return "Total PP bounty";
                }
            case 'tournament':
                return "" + bounty.tournament_name;
        }
    };
    BountyService.prototype.getBountyLabelClass = function (bounty) {
        switch (bounty.type) {
            case 'pp':
                return 'purple';
            case 'beatmap':
                return 'orange';
            case 'tournament':
                return 'blue';
        }
    };
    BountyService.prototype.likeBounty = function (bounty) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.post("bounties/" + bounty.id + "/like", {}).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BountyService.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.get('bounties/stats').toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BountyService.ngInjectableDef = i0.defineInjectable({ factory: function BountyService_Factory() { return new BountyService(i0.inject(i1.ApiService)); }, token: BountyService, providedIn: "root" });
    return BountyService;
}());
export { BountyService };
